function accountImages() {
	$('input[type="file"]').change(function() {
		var value = $("input[type='file']").val();
		$(".fileTextHolder").text(value);
	});
}